import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  dataToForm,
  RealEstateFormValues,
  UpsertIncomeDTO,
  Validation,
} from './RealEstateForm.meta';
import { IncomeDTO, IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { useUpsertIncomeMutation } from '../../api/useUpsertIncomeMutation';
import { toast } from '../../../../CommonComponents/OPL/Toast/Toast';
import {
  ADD_INCOME_SUCCESS_MESSAGE,
  EDIT_INCOME_SUCCESS_MESSAGE,
  getShowAdvanced,
} from '../../Income.meta';

interface Params {
  clientId: string;
  income: IncomeModel | null;
  onSuccess: () => void;
  data: IncomeDTO;
}

export const useRealEstateForm = ({ clientId, income, onSuccess, data }: Params) => {
  const formBag = useForm<RealEstateFormValues>({
    defaultValues: dataToForm(income, data),
    resolver: yupResolver(Validation),
  });

  const mutationBag = useUpsertIncomeMutation({ clientId });

  const defaultShowAdvanced = !!income && getShowAdvanced(income);

  const onSubmit = formBag.handleSubmit(async (values: RealEstateFormValues) => {
    const body: UpsertIncomeDTO = {
      clientId,
      ...values,
      id: income?.Id || null,
      IncomeType: IncomeType.RealEstate,
    };

    try {
      await mutationBag.mutateAsync(body);

      toast.success(income?.Id ? EDIT_INCOME_SUCCESS_MESSAGE : ADD_INCOME_SUCCESS_MESSAGE);

      onSuccess();
    } catch (error) {
      console.error(error);
    }
  });

  return {
    data: {
      formBag,
      defaultShowAdvanced,
      mutationBag,
    },
    actions: {
      onSubmit,
    },
  };
};
